import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface CulturalTraditionCardProps {
  title: string;
  description: string;
  significance: string;
  icon: string;
}

const CulturalTraditionCard = ({ title, description, significance, icon }: CulturalTraditionCardProps) => {
  return (
    <div className="bg-card rounded-lg p-6 shadow-sacred-md border border-border hover:shadow-sacred-lg transition-all duration-300">
      <div className="flex items-start space-x-4 mb-4">
        <div className="flex-shrink-0 w-12 h-12 rounded-full bg-secondary/10 flex items-center justify-center">
          <Icon name={icon as any} size={24} className="text-secondary" />
        </div>
        <div className="flex-1">
          <h3 className="font-playfair text-xl font-semibold text-foreground mb-2">
            {title}
          </h3>
          <p className="font-inter text-sm text-foreground leading-relaxed mb-3">
            {description}
          </p>
          <div className="flex items-start space-x-2 p-3 bg-surface rounded-lg">
            <Icon name="LightBulbIcon" size={18} className="text-accent flex-shrink-0 mt-0.5" />
            <div>
              <p className="font-inter text-xs font-semibold text-accent mb-1">Cultural Significance</p>
              <p className="font-inter text-xs text-muted-foreground leading-relaxed">
                {significance}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CulturalTraditionCard;